export enum EnquiryLifecycleStatusEnum {
    OPEN = 'OPEN',
    UNDER_ASSESMENT = 'UNDER ASSESMENT',
    ASSESMENT_APPROVED = 'ASSESMENT APPROVED',
    ASSESMENT_REJECTED = 'ASSESMENT REJECTED',
    COSTING_APPROVED = 'COSTING APPROVED',
    QUOTATION_SENT = 'QUOTATION SENT',
    ACCEPTANCE_PENDING = 'ACCEPTANCE PENDING',
    ACCEPTED = 'ACCEPTED',
    RENEGOTIATED = 'RENEGOTIATED',
    CLOSED = 'CLOSED',
    CANCELLED = 'CANCELLED',
    REJECTED = 'REJECTED',
    CANCELLED_AFTER_ACCEPTANCE = 'CANCELLED AFTER ACCEPTANCE'
}
